import React from "react";
import Cat8Img from '../../../../assets/images/cat8.jpg';


import './styles.css';
import "font-awesome/css/font-awesome.min.css";

const Cat8 = () => {

    return (
        <div className="container">
            <div className="row">
                <div className="siglas-title">
                    <h1>Título</h1>
                </div>
                <div className="col-sm-12">
                    <div className="siglas">
                        <img src={Cat8Img} alt="siglas" />
                    </div>
                </div>                
            </div>
        </div>
    );
};
export default Cat8;